import {INNER_PAGE, TAB} from '../../../../commons/constants/navigation'
import {RIBBON} from '../../../../commons/constants/ribbons'
import {EVENT_BADGE} from '../../../../settings-commons/components/event-badges/interfaces'
import {SettingsNavigationInfo} from '../../Settings/utils/history'
import {WidgetComponentConfig} from '../../types'
import {getFirstEvent} from '../selectors/events'
import {isCalendarLayout} from '../selectors/list-settings'
import {getComponentConfig} from '../selectors/settings'
import {createAsyncAction} from '../services/redux-toolkit'
import {closeMonthlyCalendarPopup, openAnyEventDetails, openAnyEventList} from './calendar-layout'
import {
  closeListLayoutItems,
  hideEventBadge,
  hideRibbons,
  openListLayoutItem,
  showEventBadge,
  showRibbons,
} from './layout'

export const settingsTabChanged = createAsyncAction<void, SettingsNavigationInfo>(
  'HANDLE_SETTINGS_TAB_CHANGE',
  (navigationInfo, {dispatch, getState}) => {
    if (getState().environment.mobile) {
      dispatch(handleSettingsTabChangeOnMobile(navigationInfo))
    } else {
      dispatch(handleSettingsTabChangeOnDesktop(navigationInfo))
    }
  },
)

const handleSettingsTabChangeOnMobile = createAsyncAction<void, SettingsNavigationInfo>(
  'HANDLE_SETTINGS_TAB_CHANGE_ON_MOBILE',
  ({tab, subPage}, {dispatch, getState}) => {
    if (subPage) {
      dispatch(showEventBadge(subPage as EVENT_BADGE))
    } else {
      dispatch(hideEventBadge())
    }

    if ([TAB.DISPLAY, TAB.DESIGN].includes(tab)) {
      const event = getFirstEvent(getState())
      if (event) {
        dispatch(openListLayoutItem(event.id))
      }
    } else {
      dispatch(closeListLayoutItems())
    }
  },
)

const handleSettingsTabChangeOnDesktop = createAsyncAction<void, SettingsNavigationInfo>(
  'HANDLE_SETTINGS_TAB_CHANGE_ON_DESKTOP',
  ({tab, innerPage, subPage}, {dispatch, getState}) => {
    const componentConfig = getComponentConfig(getState())

    if (innerPage === INNER_PAGE.LAYOUT_EVENT_BADGE) {
      dispatch(showEventBadge(getEventBadge(componentConfig)))
    } else {
      dispatch(hideEventBadge())
    }

    if (isCalendarLayout(componentConfig)) {
      if (
        [TAB.DISPLAY, TAB.LAYOUT].includes(tab) ||
        [
          INNER_PAGE.DESIGN_CALENDAR_DETAILS_POPUP,
          INNER_PAGE.DESIGN_BUTTONS,
          INNER_PAGE.DESIGN_RIBBONS,
          INNER_PAGE.DESIGN_RIBBON,
          INNER_PAGE.TEXT_RSVP_CLOSED,
          INNER_PAGE.TEXT_RSVP,
          INNER_PAGE.TEXT_RIBBON,
          INNER_PAGE.DESIGN_IMAGE,
          INNER_PAGE.DESIGN_EVENT_BADGE,
          INNER_PAGE.DESIGN_CALENDAR_EVENT_POPUP,
        ].includes(innerPage as INNER_PAGE)
      ) {
        dispatch(openAnyEventDetails())
      } else if (INNER_PAGE.DESIGN_CALENDAR_LIST_POPUP === innerPage) {
        dispatch(openAnyEventList())
      } else {
        dispatch(closeMonthlyCalendarPopup())
      }
    } else {
      if (innerPage === INNER_PAGE.DESIGN_HOVER || tab === TAB.DISPLAY) {
        const event = getFirstEvent(getState())
        if (event) {
          dispatch(openListLayoutItem(event.id))
        }
      } else {
        dispatch(closeListLayoutItems())
      }
    }

    if (
      subPage === EVENT_BADGE.FIRST_PRIORITY ||
      subPage === EVENT_BADGE.SECOND_PRIORITY ||
      subPage === EVENT_BADGE.THIRD_PRIORITY
    ) {
      dispatch(showEventBadge(subPage))
    } else if (subPage) {
      dispatch(showRibbons(subPage as RIBBON))
    } else {
      dispatch(hideRibbons())
    }
  },
)

const getEventBadge = (componentConfig: WidgetComponentConfig) =>
  componentConfig.settings.showFirstPriorityEventBadge
    ? EVENT_BADGE.FIRST_PRIORITY
    : componentConfig.settings.showSecondPriorityEventBadge
    ? EVENT_BADGE.SECOND_PRIORITY
    : EVENT_BADGE.THIRD_PRIORITY
